import React, { useEffect, useState, useContext } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'

import {
  createHoleProcess,
  HoleProcessProps,
  HoleProcessStoreProps,
  updateHoleProcess
} from 'src/store/ducks/holeProcess'
import Movimentation from './Movimentations'
import Sanitary from './Sanitary'

import { Button, Divider, Input, Loading, SelectInput } from 'src/components'
import { useAuth } from 'src/contexts/auth'
import { API } from 'src/services/config'
import { toast } from 'react-toastify'
import { useStyles } from './styles'

import Select, { SelectChangeEvent } from '@mui/material/Select'
import OutlinedInput from '@mui/material/OutlinedInput'
import ListItemText from '@mui/material/ListItemText'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Checkbox from '@mui/material/Checkbox'

const operations = [
  { descricao: 'Sanitária', value: 'Sanitaria' },
  { descricao: 'Reprodução', value: 'Reproducao' },
  { descricao: 'Pesagem', value: 'Pesagem' },
  { descricao: 'Movimentações', value: 'Movimentacoes' }
]

const schema = yup.object().shape({
  descricao: yup.string().required('Descrição da Tarefa é obrigatório').typeError('Campo Obrigatório'),
  dataPlanejada: yup.string().required('Data planejada é obrigatório').typeError('Campo Obrigatório'),
  idFazenda: yup.string().required('Propriedade é obrigatório').typeError('Campo Obrigatório')
})

interface UpdatePropertiesProps {
  onClose: React.MouseEventHandler | any
  value: HoleProcessProps
}

const UpdateProcess: React.FC<UpdatePropertiesProps> = ({ value, onClose }) => {
  const dispatch = useDispatch()
  const style = useStyles()

  const {
    setValue,
    handleSubmit,
    clearErrors,
    watch,
    getValues,
    formState: { errors }
  } = useForm<HoleProcessStoreProps>({ resolver: yupResolver(schema) })

  const [property, setProperty] = useState<any>([{}])
  const [isLoading, setIsLoading] = useState<any>({})
  const [lots, setLots] = useState<any>([{}])

  const { userFarm } = useAuth()

  const handleChangeLots = (event: SelectChangeEvent<typeof lots>) => {
    const {
      target: { value }
    } = event
    setValue('idLotes', typeof value === 'string' ? value.split(',') : value)
  }

  const handleChangeOperations = (event: SelectChangeEvent<any>) => {
    const {
      target: { value }
    } = event
    setValue('operacoes', typeof value === 'string' ? value.split(' ') : value)
  }

  const onFocus = () => {
    const input = document.getElementById('holeProcess-update')
    input?.focus()
  }

  const onSubmit = handleSubmit((data) => {
    data.idProcesso ? dispatch(updateHoleProcess(data)) : dispatch(createHoleProcess(data))

    setTimeout(() => {
      onClose()
    }, 800)
  })

  async function getUpdateProcess(idFazenda) {
    try {
      const response = await API.get('/entity/Fazenda')
      const responseLot = await API.get(`${'/entity/Lote'}/${idFazenda}`)

      const farmToShow = response.data.filter((item: any) => item.idFazenda === idFazenda)
      const lotsToShow = responseLot.data.filter((item: any) => item.idFazenda === idFazenda)

      setProperty(farmToShow)
      setLots(lotsToShow)

      setIsLoading(false)
    } catch (err: any) {
      toast.error('Não foi possivel carregar todos os dados, tente Novamente.')
      setProperty([{}])
      setLots([{}])
    }
  }

  useEffect(() => {
    setValue('descricao', value?.descricao)
    setValue('dataPlanejada', value?.dataPlanejada)
    setValue('dataRealizada', value?.dataRealizada)
    setValue('idProcesso', value?.idProcesso)
    setValue('movimentacoes', value?.movimentacoes)
    setValue('vacinas', value?.vacinas)
    setValue('vermifugos', value?.vermifugos)
    setValue('idFazenda', value?.idFazenda)
    setValue('id', value?.id)
    setValue('idLotes', value?.idLotes)
    setValue('operacoes', value?.operacoes)
    onFocus()
  }, [value])

  useEffect(() => {
    getUpdateProcess(userFarm)
  }, [])

  return (
    <>
      {isLoading && <Loading className={style.updateProcessLoading} />}
      <div className={style.updateProcessContainer}>
        <Input
          label='Nome da Tarefa'
          id='holeProcess-update'
          placeholder='Nome da Tarefa'
          value={watch('descricao') || ''}
          error={errors?.descricao?.message}
          className={style.updateProcessInput}
          onChange={(value: string) => {
            setValue('descricao', value)
            clearErrors('descricao')
          }}
        />
        <Input
          type='date'
          max='2999-12-31'
          label='Data Planejada'
          value={watch('dataPlanejada') || ''}
          error={errors?.dataPlanejada?.message}
          className={style.updateProcessDate1}
          onChange={(value: any) => {
            setValue('dataPlanejada', value)
            clearErrors('dataPlanejada')
          }}
        />
        <Input
          type='date'
          max='2999-12-31'
          label='Data Realizada'
          value={watch('dataRealizada') || ''}
          className={style.updateProcessDate2}
          onChange={(value: any) => setValue('dataRealizada', value)}
        />
        <SelectInput
          options={property}
          label='Propriedade'
          selectBy='idFazenda'
          showBy={['descricao']}
          value={watch('idFazenda') || ''}
          placeholder='SELECIONAR PROPRIEDADE'
          className={style.updateProcessInput}
          error={errors?.idFazenda?.message}
          onChange={(item: any) => {
            setValue('idFazenda', item.idFazenda)
            clearErrors('idFazenda')
          }}
        />
        <FormControl sx={{ width: '100%' }}>
          <InputLabel className={style.updateProcessSelectInput}>Lotes</InputLabel>
          <Select
            multiple
            onChange={handleChangeLots}
            value={watch('idLotes') || []}
            input={<OutlinedInput label='Lotes' />}
            className={style.updateProcessSelectInput}
            renderValue={(selected) => {
              const newList = selected.map((item) => {
                return lots.find((lote) => lote.idLote === item)?.descricao
              })
              return newList.join(', ')
            }}
          >
            {lots.map((lotsValue) => {
              return (
                <MenuItem className={style.updateProcessMenuItem} key={lotsValue.idLote} value={lotsValue.idLote}>
                  <Checkbox checked={(getValues('idLotes') || []).indexOf(lotsValue.idLote) > -1} />
                  <ListItemText primary={lotsValue.descricao} />
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
        <FormControl sx={{ width: '100%' }}>
          <InputLabel className={style.updateProcessSelectInput}>Operações</InputLabel>
          <Select
            multiple
            onChange={handleChangeOperations}
            value={watch('operacoes') || []}
            input={<OutlinedInput label='Operações' />}
            className={style.updateProcessSelectInput}
            renderValue={(selected) => {
              const newList = selected.map((item) => {
                return operations.find((operation) => operation.value === item)?.descricao
              })
              return newList.join(', ')
            }}
          >
            {operations.map((operationsValue) => (
              <MenuItem
                className={style.updateProcessMenuItem}
                key={operationsValue.value}
                value={operationsValue.value}
              >
                <Checkbox
                  className={style.updateProcessMenuItem}
                  checked={(getValues('operacoes') || []).indexOf(operationsValue.value) > -1}
                />

                <ListItemText className={style.updateProcessMenuItem} primary={operationsValue.descricao} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Divider className={style.updateProcessDivider} />
        {watch('operacoes')?.includes('Sanitaria') && (
          <>
            <Sanitary formSetValue={setValue} formWatch={watch} formGetValues={getValues} />
            <Divider className={style.updateProcessDivider} />
          </>
        )}
        {watch('operacoes')?.includes('Movimentacoes') && (
          <>
            <Movimentation formSetValue={setValue} formGetValues={getValues} />
            <Divider className={style.updateProcessDivider} />
          </>
        )}
        <div className={style.updateProcessButtonContainer}>
          <Button className={style.updateProcessButtonCancel} onClick={onClose}>
            Cancelar
          </Button>
          <Button className={style.updateProcessButton} onClick={onSubmit}>
            Salvar
          </Button>
        </div>
      </div>
    </>
  )
}

export default UpdateProcess
